import React from 'react';
import { useNavigate } from '@reach/router';
import { useAgilyticsDispatch, AgilyticsStateContext } from '@agilytics/global-state';
import { CookieBanner } from '@agilytics/compliance';

const levels = [
  {
    level: 'analytics',
    levelName: 'Anonymous Usage Data',
    levelDescription: `We'll collect some basic information about how you use the app. All information is used to help us make the product better. No personally identifiable information is ever collected or stored`,
  },
];

export default function ComplianceContainer() {
  const dispatch = useAgilyticsDispatch();
  const navigate = useNavigate();

  const onDismiss = () => {
    dispatch({
      type: 'hideCookiePreferences',
    });
  };

  const onComplianceChange = ({ optIn }) => {
    dispatch({
      type: 'updateComplianceOptIn',
      complianceOptIn: optIn,
    });
  };

  const onViewCookiePolicy = () => {
    navigate('/cookies');
  };

  return (
    <AgilyticsStateContext.Consumer>
      {({ showCookiePreferences }) => (
        <CookieBanner
          onViewCookiePolicy={onViewCookiePolicy}
          onChange={onComplianceChange}
          onPreferencesDismiss={onDismiss}
          showPreferences={showCookiePreferences}
          levels={levels}
        />
      )}
    </AgilyticsStateContext.Consumer>
  );
}
